import React from 'react';

import logo from './logo_ensembl.svg';
import logoSmall from './logo-small.svg';

import styles from './Logo.module.css';

type LogoProps = {
  width: number;
  height: number;
  small?: boolean;
  url?: string;
  alt?: string;
};

export const Logo: React.FC<LogoProps> = ({
  width,
  height,
  url,
  alt,
  small,
}) => (
  <div className={styles.container}>
    {small ? (
      <img
        src={url ? url : logoSmall}
        width={width}
        height={height}
        alt={alt ? alt : 'logo'}
      />
    ) : (
      <img
        src={url ? url : logo}
        width={width}
        height={height}
        alt={alt ? alt : 'logo'}
      />
    )}
  </div>
);
